import { Settings } from 'utils/constants/dynamicSettings';

import useSettings from 'hooks/useSettings';

export const useCampaignsDashboardRedesignAllowed = (): boolean => {
    const settings = useSettings();
    return settings(Settings.CampaignsDashboardRedesignAllowed) as boolean;
};
